import { Accordion } from 'enova-frontend-components';

import styled from '../styled';

export const InnerAccordion = styled(Accordion)`
  & > * {
    border: ${({ theme }) => `thin solid ${theme.palette.divider}`};
    border-top: 0;
    background: ${({ theme }) => theme.palette.background.default} !important;
  }
`;
